<template>
  <div class="refresh-page">页面刷新中...</div>
</template>

<script>
/**
 * 页面刷新仅对非keep-alive的组件有效
 * 可用于keep-alive组件数据刷新而非视图：结合deactivated方法
 */
export default {
  name: 'Refresh',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$router.replace(from.fullPath)
    })
  }
}
</script>

<style lang="scss">
  .refresh-page {
    padding: 6px 10px;
    font-size: 13px;
  }
</style>
